<template>
    <section>
        {{$route.params}} <br>        
        {{$route.query}}
    </section>
</template>

<script>
/**
 * 전체 차수 다이나믹 링크 브릿지 컴포넌트(total degree dynamic link bridge component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {dynamicMixin} from '@/mixins/dynamic.js'

export default {
    mixins: [dynamicMixin],
    async mounted() {
        this.$showLoading()

        // 브랜드 정보/언어 설정(set brand & language)
        await this.setBrandInfo()        

        // 차수 목록 / 상세로 이동(move degree list or view)
        let degreeId = this.$route.params.degreeId
        if (degreeId) {
            this.$router.push({
                name: 'DegreeView',
                params: {degreeId: degreeId},
                query: this.$route.query
            })
        }else {
            this.$router.push({
                name: 'Degree',
                query: this.$route.query
            })
        }        
        
        setTimeout(() => {
            this.$hideLoading()
        }, 1000)

        
    },
}
</script>